import { z } from 'zod';

export type ModelCode = {
    id: number,
    model_code: string,
    production_start_year: number,
    production_end_year: number | null,
};

export const ModelCodeSchema = z.object({
    id: z.number(),
    model_code: z.string(),
    production_start_year: z.number(),
    production_end_year: z.number().nullable(),
});
